<template>
  <table class="unstriped hover boss-table">
    <thead>
      <tr>
        <th class="boss-table-head-center">
          求人ID
        </th>
        <th class="boss-table-head-center">
          管理用求人名
        </th>
        <th class="boss-table-head-center">
          求人名
        </th>
        <th class="boss-table-head-center">
          掲載期間
        </th>
        <th class="boss-table-head-center">
          掲載<br>サイズ
        </th>
        <th class="boss-table-head-center">
          プレビュー
        </th>
        <th class="boss-table-head-center casual-interview-request-th">
          話を聞きたい応募<br>（カジュアル面談）<br>受付
          <a
            target="_blank"
            class="pega-circle pega-link"
            data-test="casual-interview-request-link"
            href="/help/guide/index_276.html"
          >!</a>
        </th>
        <th class="boss-table-head-center">
          応募フォームタイプ
          <a
            target="_blank"
            class="pega-circle pega-link"
            data-test="entry-form-type-link"
            href="/help/guide/index_013.html"
          >!</a>
        </th>
      </tr>
    </thead>
    <tbody>
      <preview-job-published-job
        v-for="(job, i) in jobs"
        :key="i"
        :job="job"
      />
      <tr v-if="isEmptyJob">
        <td
          colspan="8"
          data-test="no-job-label"
        >
          ※掲載中の求人情報プレビューはありません
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import PreviewJobPublishedJob from '@/components/molecules/PreviewJobPublishedJob'

export default {
  components: {
    PreviewJobPublishedJob
  },
  props: {
    jobs: {
      type: Array,
      required: true
    }
  },
  computed: {
    isEmptyJob () {
      return !this.jobs.length
    }
  }
}
</script>
